module.exports = __webpack_public_path__ + "assets/media/lunch.a27b403e.mp3";